"use client"

import { useState } from "react"
import Image from "next/image"
import Link from "next/link"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
} from "@heroui/dropdown"
import { User } from "@heroui/user"
import { signIn, signOut, useSession } from "next-auth/react"

import googleIcon from "@/assets/google-icon.svg"
import menu_icon from "@/assets/icons/menu.svg"
import SignInModal from "./home/sign-in"

export const RouterMenuNew = () => {
  const { data: session } = useSession()
  const [showDiv, setShowDiv] = useState(false)

  return (
    <>
      <Dropdown
        placement="bottom-end"
        classNames={{
          base: "before:bg-default-200",
          content: "p-0 border-small border-divider bg-background",
        }}
        radius="sm"
      >
        <DropdownTrigger>
          <Image src={menu_icon} alt="menu-icon" className="size-6" />
        </DropdownTrigger>
        <DropdownMenu aria-label="Custom item styles">
          <DropdownSection showDivider aria-label="Profile & Link">
            {session?.user ? (
              <DropdownItem key="profile" isReadOnly>
                <User
                  avatarProps={{
                    size: "sm",
                    src: session.user.image ?? "",
                  }}
                  classNames={{
                    name: "text-default-600",
                    description: "text-default-500",
                  }}
                  description={session.user.email ?? ""}
                  name={session.user.name ?? ""}
                />
              </DropdownItem>
            ) : (
              <>
                <DropdownItem
                  key="google-login"
                  textValue="Log in with Google"
                  onPress={() => signIn("google")}
                >
                  <div className="flex items-center gap-2">
                    <Image
                      src={googleIcon}
                      alt="google-icon"
                      className="size-4"
                    />
                    <span>Log in with Google</span>
                  </div>
                </DropdownItem>
                <DropdownItem
                  key="login"
                  textValue="Log In / Sign Up"
                  onPress={() => setShowDiv(!showDiv)}
                >
                  <div className="flex items-center gap-2">
                    <span>Log In / Sign Up</span>
                  </div>
                </DropdownItem>
              </>
            )}
          </DropdownSection>
          <DropdownSection
            showDivider={!!session?.user}
            aria-label="Profile & Link"
          >
            <DropdownItem key="home" href="/home" as={Link}>
              Home
            </DropdownItem>
            <DropdownItem key="brands" href="/brands" as={Link}>
              Brands
            </DropdownItem>
            <DropdownItem
              key="trending_products"
              href="trending-products"
              as={Link}
            >
              Trending Products
            </DropdownItem>
            <DropdownItem key="reviews" href="/reviews" as={Link}>
              Reviews
            </DropdownItem>
            <DropdownItem
              key="trending-snaps"
              href="https://creator.snaptheprice.com/"
              as={Link}
            >
              Partners
            </DropdownItem>
          </DropdownSection>
          {session?.user ? (
            <DropdownSection aria-label="Actions">
              <DropdownItem key="logout" onPress={() => signOut()}>
                Log Out
              </DropdownItem>
            </DropdownSection>
          ) : null}
        </DropdownMenu>
      </Dropdown>
      {showDiv && <SignInModal isOpen={showDiv} onOpenChange={setShowDiv} />}
    </>
  )
}
